export default __webpack_public_path__ + "static/media/Chariot-Logo.a015867c.png";